module.exports = __webpack_public_path__ + "img/AmSee.658bc617.jpg";